import React from 'react';
import { Reveal } from './Reveal';
import { CtaButton } from './CtaButton';
import { callSteps, qualifiers } from '../data/content';
export function FinalCta() {
  return <section className="bg-ink-900" aria-labelledby="cta-title" data-id="element-37" data-mp="19ez1nd4q3826">
      <div className="mx-auto max-w-6xl px-6 py-24 lg:py-32" data-id="element-38" data-mp="19gifyy6tj91b">
        <div className="grid gap-16 lg:grid-cols-12 lg:gap-12" data-id="element-39" data-mp="15d41ibyj30pz">
          <Reveal className="lg:col-span-6" data-id="element-40" data-mp="15fq5y2q4h03z">
            <p className="text-sm text-zinc-500" data-id="element-41" data-mp="1jc3fmpoezx7w">Siguiente paso</p>
            <h2 id="cta-title" className="mt-5 text-3xl font-semibold leading-[1.05] tracking-[-0.02em] text-white sm:text-4xl lg:text-5xl" data-id="element-42" data-mp="1eebmjsc1a524">
              Auditoría de escala.{' '}
              <span className="font-serif italic font-normal text-accent" data-id="element-43" data-mp="1o3lg7cmizvsc">
                Gratis.
              </span>
            </h2>
            <p className="mt-6 max-w-xl text-lg leading-relaxed text-zinc-400" data-id="element-44" data-mp="223w6adg0h6cg">
              30 minutos sobre tus números reales para identificar dónde está el
              gap entre lo que facturas hoy y lo que tu estructura puede
              soportar. Sales con un diagnóstico concreto, trabajemos juntos o
              no.
            </p>

            <div className="mt-10" data-id="element-45" data-mp="x3915y4xa67h">
              <CtaButton label="Reservar en Calendly" data-id="element-46" data-mp="x27c2pr2nj6r" />
            </div>

            <ul className="mt-10 space-y-2 border-t border-white/10 pt-6" data-id="element-47" data-mp="12352fpm8jjjc">
              {qualifiers.map(q => <li key={q} className="text-sm text-zinc-500" data-id="element-48" data-mp="163p2p223v39p">
                  {q}
                </li>)}
            </ul>
          </Reveal>

          <Reveal delay={0.06} className="lg:col-span-6 lg:pl-8" data-id="element-49" data-mp="1fujoy6fcq2v5">
            <p className="text-xs uppercase tracking-[0.18em] text-zinc-500" data-id="element-50" data-mp="1fwcwrp1pat4q">
              Qué pasa en esos 30 minutos
            </p>
            <ol className="mt-8 divide-y divide-white/10 border-y border-white/10" data-id="element-51" data-mp="1psppajlif0xw">
              {callSteps.map(step => <li key={step.number} className="flex gap-6 py-6" data-id="element-52" data-mp="1tv2t32gp4os1">
                  <span className="font-mono text-sm text-accent" data-id="element-53" data-mp="3quffdu883su9">
                    0{step.number}
                  </span>
                  <div data-id="element-54" data-mp="3lwneiaplowdx">
                    <h3 className="text-base font-medium text-white" data-id="element-55" data-mp="3lx5ftlr4e0sp">
                      {step.title}
                    </h3>
                    <p className="mt-2 text-sm leading-relaxed text-zinc-400" data-id="element-56" data-mp="3uwagaxm8s47i">
                      {step.body}
                    </p>
                  </div>
                </li>)}
            </ol>
          </Reveal>
        </div>
      </div>
    </section>;
}